import { LogOut } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { signOut } from "@/lib/infrastructure/auth";

/**
 * Single sign-out affordance shared by every authenticated surface (the
 * in-campaign header and the top-level campaigns list). signOut() handles its
 * own errors and always full-page-redirects to /login, so the caller can't
 * observe success/failure — the in-flight flag only disables the button during
 * the brief window before navigation to prevent a double-click.
 */
export function SignOutButton() {
  const [isSigningOut, setIsSigningOut] = useState(false);

  return (
    <Button
      aria-label="Sign out"
      disabled={isSigningOut}
      onClick={() => {
        setIsSigningOut(true);
        signOut();
      }}
      size="sm"
      type="button"
      variant="ghost"
    >
      <LogOut className="h-4 w-4" />
      <span className="hidden sm:inline">
        {isSigningOut ? "Signing out…" : "Sign out"}
      </span>
    </Button>
  );
}
